const Stepper = ({ current, total }) => {
  return (
    <div className="quiz-stepper">
      {Array.from({ length: total }).map((_, i) => {
        const step = i + 1;

        return (
          <div
            key={i}
            className={`quiz-step 
              ${step === current ? "active" : ""} 
              ${step < current ? "completed" : ""}
            `}
          />
        );
      })}
    </div>
  );
};

export default Stepper;